import React from 'react';
import { string } from 'prop-types';
import { Tag } from '@fiverr-private/data_display';
import { sendMixpanelTrackEvent } from '../../../lib/mixpanel';
import { RELATED_LINK_CLICK } from '../../../lib/mixpanel/constants';

export const TagLink = ({ link, ugcTag, name }) => {
    const onClick = () => {
        const params = {
            'Link Text': name,
        };

        sendMixpanelTrackEvent({ eventName: RELATED_LINK_CLICK, params });
    };

    return (
        <Tag size="sm" href={link} onClick={onClick}>
            {ugcTag}
        </Tag>
    );
};

TagLink.propTypes = {
    link: string,
    name: string,
    ugcTag: string,
};
